import React, { Component } from "react";
import Photosevent from "../PhotosEvent/PhotosEvent";
import UploadPhoto from "../UploadPhoto/UploadPhoto";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";

class Photos extends Component {
	state = {};

	constructor(props) {
		super(props);
		this.state = {
			uploadPhotos:[],
			showUpload: false
		};
	}

	componentDidMount() {
	}

	componentDidUpdate(prevProps, prevState) {}

	handleChange = name => event => {
//		this.setState({ ...this.state, [name]: event.target.checked });
	};

	handleCreate = () => {
		this.setState({
			showUpload: true,
			id: "",
			canDelete: false,
			eventname:"",
			uploadPhotos:[{photo:"a"}]
		});
	};

	handleClose = () => {
		this.setState({
			showUpload: false
		});
	};

	handleSave = () => {
		
	}

	photoUploaded = (location) => 
	{
		console.log(location);
	}

	thumbnailUploaded = (location) => 
	{
		console.log(location);
	}

	


	render() {
		return (
			<React.Fragment>
				<h2 style={{ width: "100%", textAlign: "left" }}>Galería de Fotos</h2>
				{
				
				!this.state.showUpload ? 
				<React.Fragment>

				
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreate}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Crear Evento
					</Button>
				</div>
                <div>
                {this.props.photos.map(p => (
                    <div><Photosevent id={p.idgalleryevent} name={p.eventname} photos={p.photos}/> &nbsp;</div>
                ))}
                </div>
				</React.Fragment>
				: 
				<UploadPhoto handleClose={this.handleClose} handleInsert={(name, file, token)=>{this.props.handleInsert(name, file, token); this.setState({showUpload:false})}} token={this.props.token}/>
		 	}
			</React.Fragment>
		);
	}
}

export default Photos;
